import React, {useContext} from 'react';
import StockTooltip from './StockTooltip';
import {isLoggedIn} from "../../../../data/user.model";
import {ProductContext} from "../../../pages/ProductStencil";
import {useSelector} from "react-redux";
import {isStockAvailabilityEnabled} from "../../../../selectors/generic";

export const StockDot = ({stockType}) => {
    const {config} = useContext(ProductContext);
    const isStockDotEnabled = useSelector(isStockAvailabilityEnabled);

    if (!stockType || !isLoggedIn() || !isStockDotEnabled) return null;

    const {Types} = config.StockInformation[0];
    const {ShortDescription, LongDescription} = Types.find(({Type}) => Type === stockType);

    return (
        <StockTooltip
            title={ShortDescription}
            description={LongDescription}
            stockType={stockType}
        >
            <svg
                className={`stock-dot stock-dot--${stockType.toLowerCase()}`}
                xmlns="http://www.w3.org/2000/svg"
                width="8"
                height="8"
                viewBox="0 0 8 8"
                fill="none"
            >
                <circle cx="4" cy="4" r="4"/>
            </svg>
        </StockTooltip>
    );
};

export default StockDot;
